import React, { useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Report_data = async (month, year, fps_id, comm_id) => {
    const response = await fetch(`${process.env.REACT_APP_URL_FPS}/fps/getfpsStockregister_scheme?fpsId=` + fps_id + '&month=' + month + '&year=' + year + '&comm_id=' + comm_id, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const FPS_Stock_details_scheme = ({ month, year, fps_id, comm_id, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div
   // console.log('--------comm_id--' + comm_id)
    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Report_data(month, year, fps_id, comm_id);

                if (response_data && Array.isArray(response_data) && response_data.length > 0) {
                    setReportData(response_data);
                } else {
                    setReportData([]);  // Ensure reportData is an array
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, fps_id]);

   // console.log(reportData);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && reportData.current) {
            reportData.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, reportData]);



    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>

                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }


    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length == 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    return (
        <>
            <table align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{reportData[0].commNameEn + ' Stock Details for FPS Id : ' + fps_id + '  ( District : ' + reportData[0].distNameEn + ')(Office:'+ reportData[0].afso_name_en + ') '} <br /> {MonthC[parseInt(month) - 1] + '-' + year}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>Scheme</th>
                        <th rowSpan={3}>Units</th>
                        <th rowSpan={3}>Alloted Qty</th>
                        <th rowSpan={3}>OB Qty<br /><br /><span class="styleDF">(A)</span></th>
                        <th colSpan={6}>Received Qty</th>
                        <th rowSpan={3}>Issued Qty<br /><br /><span class="styleDF">(E)</span></th>
                        <th rowSpan={3}>CB Qty<br /><br /><span class="styleDF">(A+B+C+D-E)</span></th>
                    </tr>
                    <tr className="tableheader">
                        <th colSpan={4}> Regular<br /><span className="styleDF"></span></th>
                        <th rowSpan={3}>Extra<br /> <span className="styleDF">(C)</span> </th>
                        <th rowSpan={3}> Moved<br /> <span className="styleDF">(D)</span></th>
                    </tr>

                    <tr className="tableheader">
                        <th>Previous Month</th>
                        <th>Current Month</th>
                        <th>Future Month</th>
                        <th> Total<br /> <span className="styleDF">(B)</span></th>



                    </tr>
                </thead>
                <tbody>
                    {
                        reportData.map((item, index) => (
                            <tr key={item.dist_code}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>{item.scheme_short_name}</td>
                                <td style={{ textAlign: 'left' }}>{item.commMeasureUnit}</td>
                                <td style={{ textAlign: 'right' }}>{item.allottedQty}</td>
                                <td style={{ textAlign: 'right' }}>{item.ob}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.prevMonth).toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.curntMonth).toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.futrMonth).toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.receivedQty}</td>
                                <td style={{ textAlign: 'right' }}>{item.extraRo}</td>
                                <td style={{ textAlign: 'right' }}>{item.sixaCase}</td>
                                <td style={{ textAlign: 'right' }}>{item.issuedQty}</td>
                                <td style={{ textAlign: 'right' }}>{item.cb}</td>

                            </tr>
                        ))
                    }
                    <tr className="tableheader">
                        <td colSpan={17} style={{ textAlign: 'right' }}>
                            Data Time:  <font style={{ color: 'red' }}>
                                {reportData[0]?.refreshTime?.substring(0, 16) || '--'}
                            </font>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default FPS_Stock_details_scheme;
